var React = require('react');

function FacebookRoundedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29 14.5C29 6.49102 22.509 0 14.5 0C6.49102 0 0 6.49102 0 14.5C0 22.509 6.49102 29 14.5 29C14.585 29 14.6699 29 14.7549 28.9943V17.7115H11.6396V14.0809H14.7549V11.4074C14.7549 8.30918 16.6467 6.62129 19.4107 6.62129C20.7361 6.62129 21.8746 6.71758 22.2031 6.76289V10.0027H20.3C18.799 10.0027 18.5045 10.7164 18.5045 11.7643V14.0752H22.1012L21.6311 17.7059H18.5045V28.4393C24.565 26.7004 29 21.1213 29 14.5Z","fill":"#F38D11"}));
}

FacebookRoundedInline.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none"};

module.exports = FacebookRoundedInline;

FacebookRoundedInline.default = FacebookRoundedInline;
